import { UnformatCurrency } from '@Components/Utilities/CurrencyFormatter';
import translator from '@Components/Utilities/Translator';

const ErrorMessages = {
    isRequired: function (fieldName) { return (fieldName == '') ? translator.getPlainTextPhrase('Sandhills.Required') : translator.translate('Sandhills.DealerServices.Boards.MVC.IsRequired', [fieldName]); },
    requiredOr: function requiredOr(otherFieldName) {
        return function (fieldName) {
            if (otherFieldName) {
                var replaceValues = [fieldName, otherFieldName];
                return translator.translate('sandhills.FieldOrOtherFieldRequired', replaceValues);
            }
            return translator.translate('Sandhills.DealerServices.Boards.MVC.IsRequired', [fieldName]);
        };
    },
    mustBeLessThan: function requiredOr(otherFieldName) {
        return function (fieldName) {
            var replaceValues = [fieldName, otherFieldName];
            return translator.translate('sandhills.FieldMustBeLessThan', replaceValues);
        };
    },
    mustBeLessThanOrEqualTo: function requiredOr(otherFieldName) {
        return function (fieldName) {
            var replaceValues = [fieldName, otherFieldName];
            return translator.translate('sandhills.fieldmustbelessthanorequalto', replaceValues);
        };
    },
    mustBeGreaterThanEqualToValue: function mustBeGreaterThanEqualToValue(value) {
        return function (fieldName) {
            var replaceValues = [value];
            return translator.translate('sandhills.valuemustbegreaterthanorequalto', replaceValues);
        };
    },
    mustMatch: function musttMatch(otherFieldName) {
        return function (fieldName) {
            var replaceValues = [fieldName, otherFieldName];
            return translator.translate('sandhills.FieldMustMatch', replaceValues);
        };
    },
    minLength: function minLength(length) {
        return function (fieldName) {
            var replaceValues = [fieldName, length];
            return translator.translate('sandhills.FieldMustBeAtLeast', replaceValues);
        };
    },
    isNotValidlEmail: function isNotValidlEmail(text) {
        return function (fieldName) {
            return translator.getPlainTextPhrase('Sandhills.CustomerEmailRequest.WebApp.EmailFormatInvalid');
        }
    },
    isNotNumeric: function () { return translator.getPlainTextPhrase('Sandhills.ValueMustBeNumeric'); },
    isNotWholeNumber: function () { return translator.getPlainTextPhrase('sandhills.tradesites.mvc.valuemustbeawholenumber'); }
};

const ValidationRules = {
    required: function (text) {
        return text ? null : ErrorMessages.isRequired;
    },
    requiredOr: function requiredOr(field, fieldName) {
        return function (value, state) {
            return (state[field] == '' && (value == undefined || value == null || value == '')) ? ErrorMessages.requiredOr(fieldName) : null;
        };
    },
    mustBeLessThan: function requiredOr(field, fieldName) {
        return function (value, state) {
            if ((state[field] && isNaN(state[field])) || (value && isNaN(value))) {
                return ErrorMessages.isNotNumeric;
            }
            let field1 = parseFloat(state[field]);
            let field2 = parseFloat(value);
            return (field1 > 0 && field2 > 0 && field1 <= field2) ? ErrorMessages.mustBeLessThan(fieldName) : null;
        };
    },
    mustBeLessThanOrEqualTo: function requiredOr(field, fieldName) {
        return function (value, state) {
            if ((state[field] && isNaN(state[field])) || (value && isNaN(value))) {
                return ErrorMessages.isNotNumeric;
            }
            let field1 = parseFloat(state[field]);
            let field2 = parseFloat(value);
            return (field1 > 0 && field2 > 0 && field1 < field2) ? ErrorMessages.mustBeLessThanOrEqualTo(fieldName) : null;
        };
    },
    mustBeGreaterThanEqualToValue: function mustBeGreaterThanEqualToValue(greaterThanValue, isCurrency, cultureCode, currency) {
        return function (value, state) {
            let valToCheck = (' ' + value).slice(1);
            if (isCurrency) {
                valToCheck = UnformatCurrency(valToCheck, cultureCode || "en-US", currency || "USD");
            }
            return (parseFloat(valToCheck) < parseFloat(greaterThanValue)) ? ErrorMessages.mustBeGreaterThanEqualToValue(greaterThanValue) : null;
        };
    },
    requiredIf: function requiredIf(condition) {
        return function (value, state) {
            return (condition && (value == undefined || value == null || value == '')) ? ErrorMessages.isRequired : null;
        };
    },
    mustMatch: function mustMatch(field, fieldName) {
        return function (text, state) {
            return state[field] === text ? null : ErrorMessages.mustMatch(fieldName);
        };
    },
    minLength: function (length) {
        return function (text) {
            return text.trim().length >= length ? null : ErrorMessages.minLength(length);
        };

    },
    minLengthIf: function (length, field) {
        return function (value, state) {
            return (state[field] == '') ? value.trim().length >= length ? null : ErrorMessages.minLength(length) : null;
        };
    },
    validEmail: function (text) {
        return /^\s*\w[\w._%+\-]*@\w(?:[._%+\-]*\w)*\.[a-zA-Z]{2,25}\s*$/.test(text) ? null : ErrorMessages.isNotValidlEmail(text);
    },
    isNumeric: function (text) {
        return (text && isNaN(text)) ? ErrorMessages.isNotNumeric : null;
    },
    isWholeNumber: function (text) {
        return (text && (isNaN(text) || !Number.isInteger(parseFloat(text)))) ? ErrorMessages.isNotWholeNumber : null;
    },
    hasValue: function (array) {
        return Array.isArray(array) && array.length > 0 ? null : ErrorMessages.isRequired;
    }
};

const ruleRunner = (field, name, ...validations) => {
    return (state) => {
        let result = null;
        validations.forEach((v) => {
            let errorMessageFunc = v(state[field], state);
            if (errorMessageFunc) {
                result = { [field]: errorMessageFunc(name) };
            }
        });
        return result;
    };
};

const run = (state, runners) => {
    return runners.reduce(function (memo, runner) {
        return Object.assign(memo, runner(state));
    }, {});
};

export { ValidationRules, ruleRunner, run };